import RichTextInput from 'ra-input-rich-text';
import React from 'react';
import { Edit, SelectInput, SimpleForm, TextInput, maxLength, required, useNotify, useRedirect } from 'react-admin';

import { CustomDateTimeInput } from '../../../commonComponents/CustomDateTimeInput';
import TargetGroupInput from '../../../commonComponents/TargetGroupInput';
import ImageInput from '../../../commonComponents/UploadInputs/ImageInput';
import {
  popupCharacterLimits,
  popupNavigationButtonTypesSelect,
  popupThemes,
  uploadTypes,
  serverApiUrl,
} from '../../../config/constants';
import PopupNavigationSelect from './PopupNavigationSelect';
import httpClient from '../../../core/httpClient';

const PopupEdit = (props) => {
  const notify = useNotify();
  const redirect = useRedirect();

  const handleSubmit = (data) => {
    const url = `${serverApiUrl}/admin/popups`;
    const body = JSON.stringify({
      ...data,
      date_from: data.date_from ? new Date(data.date_from).toISOString() : null,
      date_to: data.date_to ? new Date(data.date_to).toISOString() : null,
    });
    const options = { method: 'PUT', body };

    httpClient(url, options)
      .then(() => {
        notify('Popup has been updated', 'info');
        redirect('/admin/popups');
      })
      .catch((err) => notify(err.message, 'error'));
  };

  return (
    <Edit title="Edit popup" undoable={false} {...props}>
      <SimpleForm redirect="list" save={handleSubmit}>
        <TextInput label="Title" source="title" validate={[required(), maxLength(popupCharacterLimits.TITLE)]} />
        <RichTextInput label="Message" source="message" validate={required()} fullWidth={false} />
        <ImageInput label="Picture" imageInputSource="image" uploadType={uploadTypes.popupImage} />
        <ImageInput label="Logo" imageInputSource="logo_url" uploadType={uploadTypes.popupLogo} />
        <SelectInput label="Popup theme" source="theme" choices={popupThemes} validate={required()} />
        <TextInput
          label="Popup Button Text"
          source="button_text"
          validate={[required(), maxLength(popupCharacterLimits.BUTTON_TEXT)]}
        />
        <SelectInput label="Button type" source="button_type" choices={popupNavigationButtonTypesSelect} />
        <PopupNavigationSelect />
        <TargetGroupInput />
        <CustomDateTimeInput label="Date from" source="date_from" validate={required()} />
        <CustomDateTimeInput label="Date to" source="date_to" validate={required()} />
      </SimpleForm>
    </Edit>
  );
};

export default PopupEdit;
